import { createInstance, type i18n, type Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * Create an isolated i18next instance initialized with bundled translation
 * resources. Each app root (and each embedded chat) owns its own instance,
 * provided to the tree via `I18nextProvider` — never a shared singleton, so
 * embedding hosts with their own i18next setup are unaffected.
 */
export function createI18n(resources: Resource): i18n {
  const instance = createInstance();
  void instance.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: false,
    returnEmptyString: false,
    ns: ['common', 'errors'],
    // biome-ignore lint/style/useNamingConvention: i18next config property
    defaultNS: 'common',
    // biome-ignore lint/style/useNamingConvention: i18next config property
    fallbackNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    resources,
  });
  return instance;
}
